import { Modal } from "antd";
import styled from "styled-components";

const FullScreenModal = styled(Modal)`
  width: 90% !important;
  height: calc(100% - 48px);
  top: 24px !important;
  .ant-modal-content {
    height: 100%;
  }
  .ant-modal-body {
    height: calc(100% - 55px);
  }
  .notification-container {
    margin-bottom: 1rem;
    .note-container {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      gap: 1rem;
      p {
        margin: 0;
      }
    }
  }
`;

export { FullScreenModal };
